import React, { useState } from 'react';
import { js_utils } from '../utils/frfr-js-utils';
import ColumnWidthMinimize from './ColumnWidthMinimize';
import JSDisplayValue from './JSDisplayValue';
import JSDisplayWidgetCollapsibleHeight from './JSDisplayWidgetCollapsibleHeight';
import { VscListTree } from "react-icons/vsc";

const JSDisplayArray = (props) => {
  let arr = props.val;
  let initialDisplayStyle = 0; // DEFAULT 0 Vertical list
  if (props.initialHorizontal === true) {
    initialDisplayStyle = 1;
  }
  const [displayStyle, setDisplayStyle] = useState(initialDisplayStyle); // 0 Vertical list, 1 Horizontal, 2 Tree mode
  /*
  let jsxTableRows = arr.map((item, index) => {
    return (
      <tr key={index} className={""}>
        <td className="frfr-js-table__keyval-row__key-index">{index}</td>
        <td className="val"><JSDisplayValue val={item} cb={props.cb} primitive_validator={props.primitive_validator} /></td>
      </tr>
    );
  });
  */
  return (
    <ColumnWidthMinimize>
      <div className="jsunicompo-display-object-widget">
        <div className="jsunicompo-display-object-widget__xi-header"><span className="jsunicompo-display-object-widget__xi-header__notation"><span>{'['}</span><span>{']'}</span></span><span className="jsunicompo-display-object-widget__xi-header_title">Array</span>
          <span className={(displayStyle === 0 ? "jsunicompo-display-object-widget__xi-header__icon jsunicompo-display-object-widget__xi-header__icon--active" : "jsunicompo-display-object-widget__xi-header__icon")} onClick={() => { setDisplayStyle(0) }}><abbr title="List">{/*<i className="fa fa-list" aria-hidden="true"></i>*/}<i className="fa fa-long-arrow-down" aria-hidden="true"></i></abbr></span>
          <span className={(displayStyle === 1 ? "jsunicompo-display-object-widget__xi-header__icon jsunicompo-display-object-widget__xi-header__icon--active" : "jsunicompo-display-object-widget__xi-header__icon")} onClick={() => { setDisplayStyle(1) }}><abbr title="Horizontal list"><i className="fa fa-long-arrow-right" aria-hidden="true"></i></abbr></span>
          <span className={(displayStyle === 2 ? "jsunicompo-display-object-widget__xi-header__icon jsunicompo-display-object-widget__xi-header__icon--active" : "jsunicompo-display-object-widget__xi-header__icon")} onClick={() => { setDisplayStyle(2) }}><abbr title="Tree list">
            <VscListTree />
          </abbr></span>
        </div>
        <div className="jsunicompo-display-object-widget__xi-body">

          <JSDisplayWidgetCollapsibleHeight>
            {
              Array.isArray(arr) ? (
                <>
                  {
                    displayStyle === 1 && (
                      <table className="frfr-js-table frfr-js-table__keyval-list-horizontal">
                        <thead>
                          <tr>
                            <th scope="row" className="frfr-js-table__keyval-list-horizontal__key-index"><span>index</span></th>
                            {
                              arr.map((item, index) => {
                                return (
                                  <th key={index} className="frfr-js-table__keyval-column__key-index"><span>{index}</span></th>
                                );
                              })
                            }
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th scope="column" className="frfr-js-table__keyval-column__val"><span>value</span></th>
                            {
                              arr.map((item, index) => {
                                return (
                                  <td key={index} className="frfr-js-table__keyval-column__val"><JSDisplayValue val={item} cb={props.cb} primitive_validator={props.primitive_validator} /></td>
                                );
                              })
                            }
                          </tr>
                        </tbody>
                      </table>
                    )
                  }
                  {
                    displayStyle === 0 && (
                      <table className="frfr-js-table frfr-js-table__keyval-list-vertical">
                        <thead>
                          <tr>
                            <th className="frfr-js-table__keyval-row__key-index"><span>index</span></th>
                            <th className="frfr-js-table__keyval-row__val"><span>value</span></th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            arr.map((item, index) => {
                              return (
                                <tr key={index} className={""}>
                                  <th className="frfr-js-table__keyval-row__key-index"><span>{index}</span></th>
                                  <td className="frfr-js-table__keyval-row__val"><JSDisplayValue val={item} cb={props.cb} primitive_validator={props.primitive_validator} /></td>
                                </tr>
                              );
                            })
                          }
                        </tbody>
                      </table>
                    )
                  }
                  {
                    displayStyle === 2 && (
                      <>
                        <div className="jsunicompo-display-tree">
                          <div className="jsunicompo-display-tree__object-start"><span>{'['}</span></div>
                          <div className="jsunicompo-display-tree__object-start jsunicompo-display-tree__object-start--when-closed"><span>{'['}</span>...<span>{']'}</span></div>
                          <div className="jsunicompo-display-tree__object-keyval-list">
                            {
                              arr.map((item, index) => {
                                // const value = item;
                                return (
                                  <div key={index} className="jsunicompo-display-tree__keyval-pair">
                                    <div className="jsunicompo-display-tree__keyval-pair__index"><span>{index}</span></div>
                                    <div className="jsunicompo-display-tree__keyval-pair__keyval-separator">:</div>
                                    <div className="jsunicompo-display-tree__keyval-pair__val">
                                      <JSDisplayValue val={item} cb={props.cb} primitive_validator={props.primitive_validator} />
                                    </div>
                                  </div>
                                );
                              })
                            }
                          </div>
                          <div className="jsunicompo-display-tree__object-end"><span>{']'}</span></div>
                        </div>
                      </>
                    )
                  }
                </>
              ) : (
                <div className="jsunicompo-display-velue-error-msg"><span>ERROR: Value is not an Array!</span></div>
              )
            }
          </JSDisplayWidgetCollapsibleHeight>

        </div>
      </div>
    </ColumnWidthMinimize>
  );
};

export default JSDisplayArray;